import { render } from "./BranchModal.vue?vue&type=template&id=18ae9653"
import script from "./BranchModal.vue?vue&type=script&lang=js"
export * from "./BranchModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__